import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { HiOutlineXMark } from "react-icons/hi2";

interface VideoModalProps {
  onClose: () => void;
  children: React.ReactNode;
}

const VideoModal: React.FC<VideoModalProps> = ({ onClose, children }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  const portalTarget =
    typeof document !== "undefined"
      ? document.getElementById("modal-root") || document.body
      : null;

  if (!portalTarget) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-3 sm:p-6 w-full max-w-4xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          onClick={onClose}
          type="button"
          className="absolute -top-2 -right-2 z-10 w-11 h-11 rounded-full bg-white dark:bg-gray-700 shadow-lg flex items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors touch-manipulation"
          aria-label="Close"
        >
          <HiOutlineXMark className="w-6 h-6" strokeWidth={2} />
        </button>
        {children}
      </div>
    </div>,
    portalTarget
  );
};

export default VideoModal;
